export default __webpack_public_path__ + "static/media/data-storage.bfeac784.svg";